import React from 'react';
import ConfigureStep from '../onboard/ConfigureStep';

interface ConfigureMpxListenerStepProps {
  channelConfig: any;
  listenerFormState: any;
  onConfigChange: (config: any, formState: any) => void;
  onBack: () => void;
}

/**
 * Wrapper component for MPX channel listener configuration.
 * Uses the standard ConfigureStep with MPX protocol to handle
 * listener selection (host:port, route, etc.) and basic configuration
 * (name, description).
 */
const ConfigureMpxListenerStep: React.FC<ConfigureMpxListenerStepProps> = ({
  channelConfig,
  listenerFormState,
  onConfigChange,
  onBack
}) => {
  return (
    <ConfigureStep
      protocol="mpx"
      capturedPayload={null}
      derivedSchema={null}
      initialFormState={listenerFormState}
      onConfigurationComplete={onConfigChange}
      onBack={onBack}
    />
  );
};

export default ConfigureMpxListenerStep;
